import { Button, Card, Checkbox, Col, Form, Row, message } from "antd";
import TextArea from "antd/es/input/TextArea";
import { collection, doc, updateDoc } from "firebase/firestore";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "../../../../firebase";
import FormAction from "../../../../components/common/FormAction";

function OwnerStatement({ data, renderData, companyName }) {
  const [checked, setChecked] = useState(false);
  //console.log("Owner statement", data)

  // const [form] = Form.useForm();
  const { id } = useParams();

  const onFinish = async (values) => {
    //  console.log("Owner statement success", values)
    // form.setFieldValue(values);

    const companiesRef = collection(db, "companies");
    const companyDocRef = doc(companiesRef, companyName);
    const ownerRef = collection(companyDocRef, "owners");

    try {
      await updateDoc(doc(ownerRef, id), {
        ownerStatement: values,
      });

      message.success("Owner Statement data Updated SuccessFully!");
      setChecked(false);
      renderData(true);
    } catch (err) {
      console.error(err);
      message.error(err.message);
    }
  };
  const onFinishedFailed = async (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("Owner Statement data Update Failed!");
  };
  const onCancel = () => {
    setChecked(false);
  };
  const defaultValues = {
    showTransactionsDetail: data?.showTransactionsDetail
      ? data?.showTransactionsDetail
      : false,
    showUnpaidBillsDetail: data?.showUnpaidBillsDetail
      ? data?.showUnpaidBillsDetail
      : false,
    showTenantNames: data?.showTenantNames ? data?.showTenantNames : false,
    showSummary: data?.showSummary ? data?.showSummary : false,
    seperateManagementFeeFromCashOut: data?.seperateManagementFeeFromCashOut
      ? data?.seperateManagementFeeFromCashOut
      : false,
    notesForOwners: data?.notesForOwners ? data?.notesForOwners : " ",
  };
  return (
    <Row>
      <Col span={24}>
        <Card
          title="Owner Statement (Enhanced)"
          extra={
            !checked ? (
              <span className="onclick-text" onClick={() => setChecked(true)}>
                Edit
              </span>
            ) : null
          }
        >
          {checked ? (
            <div>
              <Col span={24}>
                <Form
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 11 }}
                  labelWrap={{ span: 8 }}
                  onFinish={onFinish}
                  onFinishFailed={onFinishedFailed}
                  initialValues={defaultValues}
                >
                  <Form.Item
                    label="Show Transactions Detail"
                    name="showTransactionsDetail"
                    valuePropName="checked"
                  >
                    <Checkbox></Checkbox>
                  </Form.Item>
                  <Form.Item
                    label="Show Unpaid Bills Detail"
                    name="showUnpaidBillsDetail"
                    valuePropName="checked"
                  >
                    <Checkbox></Checkbox>
                  </Form.Item>
                  <Form.Item
                    label="Show Tenant Names"
                    name="showTenantNames"
                    valuePropName="checked"
                  >
                    <Checkbox></Checkbox>
                  </Form.Item>
                  <Form.Item
                    label="Show Summary"
                    name="showSummary"
                    valuePropName="checked"
                  >
                    <Checkbox></Checkbox>
                  </Form.Item>
                  <Form.Item
                    label="Separate Management Fees from Cash Out"
                    name="seperateManagementFeeFromCashOut"
                    valuePropName="checked"
                  >
                    <Checkbox></Checkbox>
                  </Form.Item>
                  <Form.Item label="Notes for the Owner" name="notesForOwners">
                    <TextArea rows={8} />
                  </Form.Item>

                  <FormAction
                    className="contact-actions"
                    submit={"submit"}
                    cancel={onCancel}
                  />
                </Form>
              </Col>
            </div>
          ) : (
            <Form
              colon={false}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 11 }}
              labelWrap={{ span: 8 }}
            >
              <Form.Item label="Show Transactions Detail">
                <p>{data?.showTransactionsDetail ? "Yes" : "No"}</p>
              </Form.Item>
              <Form.Item label="Show Unpaid Bills Detail">
                <p>{data?.showUnpaidBillsDetail ? "Yes" : "No"}</p>
              </Form.Item>
              <Form.Item label="Show Tenant Names">
                <p>{data?.showTenantNames ? "Yes" : "No"}</p>
              </Form.Item>
              <Form.Item label="Show Summary">
                <p>{data?.showSummary ? "Yes" : "No"}</p>
              </Form.Item>
              <Form.Item label="Separate Management Fees from Cash Out">
                <p>{data?.seperateManagementFeeFromCashOut ? "Yes" : "No"}</p>
              </Form.Item>
              <Form.Item label="Notes for the Owner">
                <p>{data?.notesForOwners ? data?.notesForOwners : "--"}</p>
              </Form.Item>
            </Form>
          )}
        </Card>
      </Col>
    </Row>
  );
}

export default OwnerStatement;
